import React from 'react';
import DishesContainer from '../dishes/DishesContainer';


const DayOverview = ({
	day,
	dishes,
}) => (
	<div>
		<div className="day">
			{day}
		</div>
		<DishesContainer
			dishes={dishes} />
	</div>
);

export default DayOverview;


// WEBPACK FOOTER //
// ./src/gui/DayOverview.js